import { render, staticRenderFns } from "./ExposureBox.vue?vue&type=template&id=6609668a&scoped=true"
import script from "./ExposureBox.vue?vue&type=script&lang=js"
export * from "./ExposureBox.vue?vue&type=script&lang=js"
import style0 from "./ExposureBox.vue?vue&type=style&index=0&id=6609668a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6609668a",
  null
  
)

export default component.exports